import React, { Component } from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
} from "devextreme-react/data-grid";
import uiInfo from "../../../ui-info";
import { criarCpbsDs } from "../../../DataSources";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import notify from "devextreme/ui/notify";
import { Button } from "devextreme-react";
import apiAxios from "../../../api-axios";
import UserInfo from "../../../UserInfo";
import Toolbar, { Item } from "devextreme-react/toolbar";
import ShowError from "../../../AppServices";

export default class CnaesCpbsBox extends Component {
  constructor() {
    super();
    this.formAddCnaeRef = React.createRef();
    this.focarCodigoCnae = this.focarCodigoCnae.bind(this);

    this.cpbsDs = criarCpbsDs();
    this.ok = this.ok.bind(this);
    this.state = { contribuinteNome: "", cnaesDs: [], principal: false };

    this.atividadeOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: true, descricao: "Sim" },
        { id: false, descricao: "Não" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  componentDidMount() {
    console.log("props:", this.props);

    const cpbsId = this.props.match.params.inscricao;

    this.cpbsDs
      .load({ filter: [["id", "=", this.props.match.params.inscricao]] })
      .then((data) => {
        if (data === undefined) {
          notify("CPBS não encontrado.", "error");
          this.props.history.push("/cpbs");
        }
        apiAxios
          .get(`/cpbs/prefeitura/${UserInfo.getPrefeitura()}/${cpbsId}/cnaes`)
          .then((dataCnaes) => {
            if (data[0] !== undefined) {
              this.setState({
                cnaesDs: dataCnaes.data.data,
                cpbsId: data[0].id,
                contribuinteNome: data[0].contribuinte.nome,
              });
            }
          });
      })
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
        this.props.history.push("/cpbs");
      });
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Toolbar>
            <Item
              location="left"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "Voltar",
                icon: "arrowleft",
                onClick: () => {
                  let id = localStorage.getItem("id_cpbs");
                  localStorage.removeItem("id_cpbs");
                  localStorage.removeItem("inscricao_cpbs");
                  this.props.history.push("/cpbs/editar/" + id);
                },
              }}
            />
          </Toolbar>
          <Form
            formData={this.state}
            colCount={3}
            labelLocation={"top"}
            ref={this.formAddCnaeRef}
          >
            <GroupItem caption="DADOS CPBS" colSpan={3} colCount={5}>
              <SimpleItem
                dataField={"inscricao"}
                colSpan={1}
                cssClass={"readOnlyBox"}
                editorOptions={{ readOnly: true }}
              >
                <Label text="Inscrição" />
              </SimpleItem>
              <SimpleItem
                dataField={"contribuinteNome"}
                colSpan={4}
                cssClass={"readOnlyBox"}
                editorOptions={{ readOnly: true }}
              >
                <Label text="Nome" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="ADICIONAR CNAE" colSpan={3} colCount={5}>
              <SimpleItem dataField={"codigoCnae"} colSpan={1}>
                <Label text="Código Cnae" />
              </SimpleItem>
              <SimpleItem
                dataField={"principal"}
                editorType={"dxSelectBox"}
                editorOptions={this.atividadeOptions}
                colSpan={1}
              >
                <Label text="Atividade Principal" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div style={{ display: "inline-block" }}>
            <Button
              width={120}
              text="Incluir Cnae"
              type="success"
              onClick={this.ok}
            />
          </div>
          <br />

          <br />
          <h3>CNAES do CPBS</h3>
          <DataGrid
            ref={(grid) => (this._gridInstance = grid)}
            dataSource={this.state.cnaesDs}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            wordWrapEnabled={true}
          >
            <Editing
              mode={"row"}
              allowAdding={false}
              allowUpdating={false}
              allowDeleting={false}
            />
            <Column
              type="buttons"
              fixed={true}
              fixedPosition={"left"}
              caption="Excluir"
              buttons={[
                {
                  icon: "remove",
                  text: "Excluir CNAE",
                  onClick: (e) => {
                    console.log("exclusao cnae", e);
                    apiAxios
                      .post(
                        `/cpbs/prefeitura/${UserInfo.getPrefeitura()}/excluir_cnae`,
                        {
                          cpbsId: e.row.key.cpbsId,
                          cnaeId: e.row.key.cnaeId,
                        }
                      )
                      .then((response) =>
                        this.setState({ cnaesDs: response.data })
                      )
                      .catch((error) => {
                        if (error.response && error.response.data) {
                          ShowError(error.response.data);
                        } else {
                          ShowError(error.message);
                        }
                      });
                  },
                },
              ]}
            />
            <Column
              dataField={"ordem"}
              caption={"Ordem"}
              visible={false}
              sortOrder={"asc"}
              sortIndex={1}
            />
            <Column dataField={"cnae.codigo"} caption={"CNAE"} width={90} />
            <Column
              dataField={"principalStr"}
              caption={"Principal"}
              width={80}
            />
            <Column dataField={"cnae.descricao"} caption={"Descrição"} />

            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </div>
      </React.Fragment>
    );
  }

  focarCodigoCnae() {
    this.formAddCnaeRef.current.instance.getEditor("codigoCnae").focus();
  }

  ok() {
    const entidade = {
      cpbsId: this.state.cpbsId,
      cnae: this.state.codigoCnae,
      principal: this.state.principal,
    };
    console.log(entidade);
    apiAxios
      .post(`/cpbs/prefeitura/${UserInfo.getPrefeitura()}/add_cnae`, entidade)
      .then((response) => {
        notify("Cadastro efetuado com sucesso", "success");
        apiAxios
          .get(
            `/cpbs/prefeitura/${UserInfo.getPrefeitura()}/${
              entidade.cpbsId
            }/cnaes`
          )
          .then((dataCnaes) => {
            console.log("dt", dataCnaes);
            this.setState(
              {
                cnaesDs: dataCnaes.data.data,
                codigoCnae: "",
              },
              this.focarCodigoCnae
            );
          });
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          ShowError(error.response.data);
        } else {
          ShowError(error.message);
        }
      });
  }
}
